import type { ProgramSponsor } from 'models';
import { Trans } from 'react-i18next';
import { Avatar } from 'ui';
import { Paragraph } from 'ui/typography';
import { useGetSponsorValue } from '../../../../hooks';

type P = {
  price?: number;
  sponsors: ProgramSponsor[];
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramSponsorList = ({ price, sponsors }: P) => {
  const getSponsorValue = useGetSponsorValue();

  return (
    <>
      {sponsors.map((sponsor) => (
        <Paragraph className="program-topbar__sponsor" key={sponsor.name}>
          <div className="program-topbar__sponsor__name">
            {getSponsorValue(price, sponsor.price)} <Trans>Sponsored by</Trans> {sponsor.name}
          </div>
          <Avatar className="program-topbar__sponsor__logo" photo={sponsor.logo?.url} size={35} />
        </Paragraph>
      ))}
    </>
  );
};

export default ProgramSponsorList;
